/* WEELZ - minimal legacy carousel fallback.

   Activates ONLY when the modern Horizon slideshow custom element never
   got defined (import maps unsupported -> the whole module graph is dead,
   e.g. iOS 15). On modern browsers this file detects the upgrade and does
   absolutely nothing.

   Native CSS scroll-snap (see slideshow-styles) already provides swipe +
   snap with no JS at all. This adds only the click affordances on top:
     - previous / next arrows
     - thumbnail / dot / select-slide clicks
     - aria-hidden / aria-selected sync on scroll settle

   Deliberately classic JavaScript: no import/export, no modules, no
   third-party code, Safari 15-safe syntax (no ?. / ??). Not a slider
   engine - scrollIntoView does the work. */
(function () {
  'use strict';

  function enhance(comp) {
    if (comp.getAttribute('data-weelz-legacy')) return;
    comp.setAttribute('data-weelz-legacy', '1');

    var scroller = comp.querySelector('slideshow-slides');
    if (!scroller) return;
    var slides = scroller.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;

    /* RTL-safe active detection: compare slide centers to the scroller
       center in viewport coordinates instead of trusting scrollLeft,
       whose sign convention in RTL differs across engines. */
    function activeIndex() {
      var sRect = scroller.getBoundingClientRect();
      var center = sRect.left + sRect.width / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function goTo(i) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      try {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } catch (e) {
        slides[i].scrollIntoView();
      }
    }

    var prev = comp.querySelector('.slideshow-control--previous');
    var next = comp.querySelector('.slideshow-control--next');
    if (prev) prev.addEventListener('click', function (ev) { ev.preventDefault(); goTo(activeIndex() - 1); });
    if (next) next.addEventListener('click', function (ev) { ev.preventDefault(); goTo(activeIndex() + 1); });

    /* Horizon renders declarative handlers as on:click="/select/N" on
       thumbnails, dots and clickable slides. Reuse them as plain data. */
    var selects = comp.querySelectorAll('[on\\:click^="/select/"]');
    Array.prototype.forEach.call(selects, function (el) {
      var m = (el.getAttribute('on:click') || '').match(/\/select\/(\d+)/);
      if (!m) return;
      var idx = parseInt(m[1], 10);
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        goTo(idx);
      });
    });

    var t = null;
    scroller.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        var a = activeIndex();
        for (var i = 0; i < slides.length; i++) {
          slides[i].setAttribute('aria-hidden', i === a ? 'false' : 'true');
        }
        Array.prototype.forEach.call(selects, function (el) {
          var m = (el.getAttribute('on:click') || '').match(/\/select\/(\d+)/);
          if (m) el.setAttribute('aria-selected', parseInt(m[1], 10) === a ? 'true' : 'false');
        });
      }, 120);
    }, { passive: true });
  }

  function scan() {
    var comps = document.querySelectorAll('slideshow-component');
    Array.prototype.forEach.call(comps, enhance);
  }

  function init() {
    var upgraded = window.customElements && customElements.get && customElements.get('slideshow-component');
    if (upgraded) return; // modern Horizon is alive - stay out of the way
    document.documentElement.classList.add('weelz-legacy-carousel');
    scan();
    // Recommendations and section-rendered content can arrive late.
    setTimeout(scan, 2500);
    setTimeout(scan, 6000);
  }

  // Give module scripts every chance to run first.
  if (document.readyState === 'complete') {
    setTimeout(init, 900);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 900); });
  }
})();
